import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/logo2.png";
import { FaArrowLeft, FaCommentDots } from "react-icons/fa";
import { getSiteSettings } from "../services/api";

export default function Feedback() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [feedbackUrl, setFeedbackUrl] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getSiteSettings()
      .then((s) => setFeedbackUrl(s.feedback_url || s.contact_form_url || ""))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <div className="min-h-screen bg-[#f5f5f0]">
      <header className="bg-white border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2.5">
            <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center overflow-hidden shadow-sm border border-gray-100 shrink-0">
              <img src={logo} alt="UCH" className="w-7 h-7 object-contain" />
            </div>
            <div>
              <p className="font-bold text-gray-900 text-sm leading-tight">UCH Self Service</p>
              <p className="text-gray-400 text-[11px]">University College Hospital</p>
            </div>
          </a>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <button
          onClick={() => navigate(user ? "/dashboard" : "/")}
          className="inline-flex items-center gap-2 text-sm font-semibold text-[#0d3d2e] border border-green-200 rounded-xl px-4 py-2 hover:bg-green-50 transition mb-6"
        >
          <FaArrowLeft className="w-3 h-3" /> Back
        </button>

        <div className="flex items-center gap-3 mb-1.5">
          <div className="w-10 h-10 bg-green-50 rounded-xl flex items-center justify-center">
            <FaCommentDots className="text-[#0d3d2e] w-4 h-4" />
          </div>
          <h1 className="text-3xl font-black text-gray-900">Feedback</h1>
        </div>
        <p className="text-gray-500 mb-8">
          We'd love to hear about your experience using UCH Self Service.
        </p>

        {feedbackUrl ? (
          <div className="bg-white rounded-2xl border border-gray-100 p-6 sm:p-7">
            <iframe
              src={feedbackUrl}
              width="100%"
              height="700"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Feedback Form"
              className="rounded-xl"
            >
              Loading form...
            </iframe>
          </div>
        ) : loaded ? (
          <div className="bg-white rounded-2xl border border-gray-100 p-10 text-center text-gray-400 text-sm">
            Feedback form is not available at the moment.
          </div>
        ) : null}
      </div>
    </div>
  );
}
